import axios from 'axios'
import { environment } from '@/data/environment/'

export default {
  namespaced: true,
  state: {
    statusResponseUser: false,
    listUsers: [],
    responsePassword: null,

  },
  mutations: {

    setListUsers (state, data) {
      state.listUsers = data
    },
    setResponseUser (state, data) {
      state.statusResponseUser = data
    },
    setResponsePassword (state, data) {
      state.responsePassword = data
      state.error = null
    },

  },
  actions: {
    getListUsers ({ commit }) {
      const endpoint = '/getUsers'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      axios
        .create()
        .get(url)
        .then(response => {
          commit('setListUsers', response.data)
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    insertUser ({ commit }, data) {
      const endpoint = '/insertUsers'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      return axios
        .create()
        .post(url, data)
        .then(response => {
          if (response.data.Mensaje) {
              commit('setResponseUser', response.data.Mensaje)
          }
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    setStatusResponse ({ commit }, data) {
      commit('setResponseUser', data)
    },
    sendPassword ({ commit }, data) {

      const endpoint = '/updatePassword?'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      axios
        .create()
        .post(url, data)
        .then(response => {
          console.log(response)
          commit('setResponsePassword', response.data.Mensaje)
        })
        .catch(function (error) {
          commit('setResponsePassword', null)
          console.log(error.message)
        })
    },

    sendPasswordEmail ({ commit }, data) {
      const endpoint = '/updatePasswordEmail'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      return axios
        .create()
        .post(url, data)
        .then(response => {
          commit('setResponsePassword', response.data)
        })
        .catch(function (error) {
          const mensaje = error.response?.data?.Mensaje || 'Hubo un problema al actualizar la contraseña. Intente nuevamente.'
          commit('setResponsePassword', { error: true, Mensaje: mensaje })
        })
    },

    setResponsePassword ({ commit }, data) {
      commit('setResponsePassword', data)
    },

    updateUser ({ commit }, data) {
      // Actualiza usuario (name, email, rol, IdCompania)
      // Si data.password existe, también actualiza la contraseña
      const endpoint = '/updateUser'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      return axios
        .create()
        .post(url, data)
        .then(response => {
          const responseData = response.data

          if (responseData.Mensaje) {
            commit('setResponseUser', responseData.Mensaje)
          }
          return responseData
        })
        .catch(function (error) {
          if (error.response) {
            // El servidor respondió con error
            const mensaje = error.response.data?.Mensaje || 'Error al actualizar usuario'
            throw new Error(mensaje)
          }
        })
    },

    updateStatusUser ({ commit }, data) {
      const endpoint = '/updateStatusUser'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      return axios
        .create()
        .post(url, { id: data.id, estado: data.estado })
        .then(response => {
          const responseData = response.data
          if (responseData.Mensaje) {
            commit('setResponseUser', responseData.Mensaje)
          }
          return responseData
        })
        .catch(function (error) {
          const mensaje = error.response?.data?.Mensaje || 'Error al cambiar el estado del usuario'
          throw new Error(mensaje)
        })
    },

    deleteUser ({ commit }, data) {
      const endpoint = '/deleteUser'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      return axios
        .create()
        .post(url, { id: data.id })
        .then(response => {
          const responseData = response.data
          if (responseData.Mensaje) {
            commit('setResponseUser', responseData.Mensaje)
          }
          return responseData
        })
        .catch(function (error) {
          const mensaje = error.response?.data?.Mensaje || 'Error al eliminar el usuario'
          throw new Error(mensaje)
        })
    },

  },
}
